<template>
  <transition name="fade" mode="out-in">
    <div class="page" :class="(dark ? 'quiz-dark' : 'quiz-light')">
      <div v-if="showScore" class="modal-container">
        <div class="modal score-modal">  

          <CircleProgress
            :score="true"
            :percentage="finalPercent"
            :progressColor="'black'"
            :circleColor="'rgba(0,0,0,0.06)'"
            :strokeWidth="8"
            :showNumber="true"
            :separated="false"
            class="circle-boi"
            :pass="pass"
            :fail="fail"
          />

          <h2 class="score-message" :class="( pass ? 'pass-message' : 'fail-message' )">{{ ( pass ? 'You passed!' : 'You need a 90% or higher to pass' ) }}</h2>

          <div class="score-options-container">
            <router-link v-if="pass" class="btn btn1" :to="nextRoute"><div><span>Next Lesson 🡒</span></div></router-link>
            <div v-if="fail" class="btn btn1"><div @click="$router.go(0)"><span>Retake Quiz</span></div></div>
            <router-link :to="'/lesson/' + $route.params.current"><div class="btn btn2"><span>Review Lesson</span></div></router-link>
            <router-link to="/dashboard"><div class="btn btn3"><span>Return to Dashboard</span></div></router-link>
          </div>

          <!--h1 class="final-percent" :class="(this.pass ? 'pass' : (this.fail ? 'fail' : ''))">{{animatedProgress}}%</h1-->
          <!--div class="score-bar">
            <div class="juice-container">
              <div class="juice">
                <div class="juice-progress" :style="'width:' + finalPercent + '%'"></div>
              </div>
              <div class="juice-backdrop-container">
                <div class="juice-empty"></div>
                <div class="pass-marker"></div>
              </div>
            </div>
          </div-->

        </div>
      </div>
      <div class="quiz-container">
        <full-page ref="fullpage" :options="options" id="fullpage">
          <div class="section quiz-intro">
            <div class="quiz-intro-inner">
              <div class="draw-intro">
                <svg id="logo" width="184" height="53" viewBox="0 0 184 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path id="p1" d="M40.9172 4.99862V4.49862H40.4172H1H0.5V4.99862V11.4525V11.9525H1H16.4361V51.2985V51.7985H16.9361H24.4811H24.9811V51.2985V11.9525H40.4172H40.9172V11.4525V4.99862ZM43.1437 51.2985V51.7985H43.6437H51.1887H51.6887V51.2985V32.7084C51.6887 30.4324 52.1233 28.5851 52.96 27.1384C53.863 25.6119 54.9538 24.5139 56.2242 23.8166L56.2243 23.8166L56.2292 23.8138C57.5704 23.0577 58.9438 22.6857 60.3555 22.6857C61.422 22.6857 62.2248 22.7555 62.7821 22.8835L62.8027 22.8882L62.8237 22.8912C63.4546 22.9808 64.0078 23.114 64.4868 23.2872L65.0549 23.4928L65.1505 22.8962L66.2082 16.302L66.2665 15.9389L65.9372 15.7752C65.4077 15.5117 64.7684 15.337 64.0335 15.2383C63.3021 15.0938 62.5696 15.0213 61.8363 15.0213C59.0384 15.0213 56.6541 15.6216 54.7112 16.8528C53.2157 17.8004 52.0037 19.108 51.0704 20.7606L50.5574 16.1673L50.5078 15.7228H50.0605H43.6437H43.1437V16.2228V51.2985ZM72.4882 9.49201L72.498 9.5018L72.5084 9.51102C73.5226 10.4138 74.927 10.8301 76.6486 10.8301C78.3257 10.8301 79.6887 10.4124 80.6577 9.50194L80.6582 9.50141C81.6731 8.54494 82.1551 7.23181 82.1551 5.62998C82.1551 4.03188 81.6748 2.7361 80.6526 1.82344C79.6839 0.916249 78.3227 0.5 76.6486 0.5C74.927 0.5 73.5226 0.916293 72.5084 1.8191L72.5083 1.81896L72.4985 1.82818C71.5247 2.74314 71.0716 4.03751 71.0716 5.62998C71.0716 7.22394 71.5251 8.53388 72.4882 9.49201ZM80.8858 16.2228V15.7228H80.3858H72.8409H72.3409V16.2228V51.2985V51.7985H72.8409H80.3858H80.8858V51.2985V16.2228ZM115.39 15.7228H115.038L114.919 16.0543L105.172 43.2729L95.6951 16.0584L95.5782 15.7228H95.2229H86.9023H86.1623L86.4384 16.4094L100.541 51.485L100.667 51.7985H101.005H109.255H109.594L109.719 51.4842L123.752 16.4086L124.026 15.7228H123.287H115.39ZM129.367 9.49201L129.377 9.5018L129.388 9.51102C130.402 10.4138 131.806 10.8301 133.528 10.8301C135.205 10.8301 136.568 10.4124 137.537 9.50194L137.537 9.50141C138.552 8.54494 139.034 7.23181 139.034 5.62998C139.034 4.03197 138.554 2.73624 137.532 1.82359C136.563 0.916293 135.202 0.5 133.528 0.5C131.806 0.5 130.402 0.916293 129.388 1.8191L129.388 1.81896L129.378 1.82818C128.404 2.74314 127.951 4.03752 127.951 5.62998C127.951 7.22393 128.404 8.53388 129.367 9.49201ZM137.765 16.2228V15.7228H137.265H129.72H129.22V16.2228V51.2985V51.7985H129.72H137.265H137.765V51.2985V16.2228ZM167.115 23.7263L167.121 23.7328L167.128 23.7391C168.32 24.8827 168.949 26.5373 168.949 28.7799V29.7011L156.801 32.0774L156.795 32.0786C153.583 32.7464 151.042 33.9486 149.216 35.7164L149.211 35.7212C147.417 37.5064 146.525 39.7656 146.525 42.4594C146.525 45.7695 147.684 48.3199 150.047 50.0207C152.359 51.6847 155.242 52.5 158.66 52.5C160.843 52.5 163.021 52.0653 165.191 51.2019L165.2 51.1983C167.063 50.4157 168.572 49.3114 169.713 47.882C170.267 49.2213 171.149 50.275 172.359 51.0224C173.814 51.9209 175.53 52.3597 177.487 52.3597C179.181 52.3597 180.623 52.0955 181.792 51.5395L182.052 51.4158L182.075 51.1286L182.498 45.9375L182.557 45.2128L181.86 45.417C181.107 45.6372 180.331 45.7476 179.532 45.7476C178.739 45.7476 178.236 45.5506 177.928 45.2442C177.62 44.9384 177.423 44.4395 177.423 43.652V28.0083C177.423 25.1299 176.772 22.71 175.434 20.7835C174.153 18.8263 172.357 17.3862 170.064 16.463C167.831 15.4978 165.295 15.0213 162.468 15.0213C158.263 15.0213 154.775 15.9007 152.039 17.6991L152.036 17.7014C149.36 19.4924 147.547 21.876 146.619 24.8424L146.483 25.2765L146.902 25.4527L153.248 28.1185L153.761 28.334L153.921 27.8009C154.554 25.6854 155.577 24.2093 156.956 23.3078C158.415 22.3849 160.152 21.914 162.186 21.914C164.341 21.914 165.961 22.536 167.115 23.7263ZM168.949 35.9872V38.3205C168.949 40.1116 168.522 41.516 167.711 42.5768L167.711 42.5767L167.704 42.5872C166.919 43.6721 165.873 44.4544 164.553 44.9361C163.201 45.4292 161.755 45.6774 160.211 45.6774C158.596 45.6774 157.349 45.3219 156.425 44.6575C155.567 43.962 155.141 43.0577 155.141 41.8982C155.141 40.6741 155.556 39.8072 156.345 39.2157C157.246 38.5775 158.665 38.058 160.655 37.6898L160.664 37.6879L168.949 35.9872Z" stroke="black"/>
                </svg>
              </div>
              <div @click="$refs.fullpage.api.moveSectionDown()" class="begin-button score-button primary-btn">Begin</div>
              <div class="arrows"></div>
            </div>
          </div>

          <div class="section fp-section fp-table" v-for="(item, index) in questions" :key="index">
            <div class="quiz-card" :id="'quiz-card' + index" :class="( !((activeSlide - 1) == index) ? 'card-inactive' : '' )">
              <h3 :style="( messages[index].status == 1 ? 'color: green' : ( messages[index].status == 2 ? 'color: red' : 'color: black' ))" class="question-title"><span style="opacity:0.3; margin-right: 24px">{{ index + 1 + ' / ' + questions.length  }}</span>{{ messages[index].q }}</h3>
                <div class="answers-container">

                  <div class="question-container">
                    <div :id="'a' + parseInt(((index + 1) * 4) - 3)" @click="handleAns(questions[index]['answer1'], parseInt(((index + 1) * 4) - 3), index)" :class="(!remove[parseInt(((index + 1) * 4) - 3)] ? 'a-appear' : 'a-disappear' ) + ' ' + (item.answer1 + ' ' + (sheet[index].answered == 1 ? 'answer-selected' : ''))" class="answer answer1"></div>
                    <div :id="'a' + parseInt(((index + 1) * 4) - 2)" @click="handleAns(questions[index]['answer2'], parseInt(((index + 1) * 4) - 2), index)" :class="(!remove[parseInt(((index + 1) * 4) - 2)] ? 'a-appear' : 'a-disappear' ) + ' ' + (item.answer2 + ' ' + (sheet[index].answered == 2 ? 'answer-selected' : ''))" class="answer answer2"></div>
                    <div :id="'a' + parseInt(((index + 1) * 4) - 1)" @click="handleAns(questions[index]['answer3'], parseInt(((index + 1) * 4) - 1), index)" :class="(!remove[parseInt(((index + 1) * 4) - 1)] ? 'a-appear' : 'a-disappear' ) + ' ' + (item.answer3 + ' ' + (sheet[index].answered == 3 ? 'answer-selected' : ''))" class="answer answer3"></div>
                    <div :id="'a' + parseInt(((index + 1) * 4) - 0)" @click="handleAns(questions[index]['answer4'], parseInt(((index + 1) * 4) - 0), index)" :class="(!remove[parseInt(((index + 1) * 4) - 0)] ? 'a-appear' : 'a-disappear' ) + ' ' + (item.answer4 + ' ' + (sheet[index].answered == 4 ? 'answer-selected' : ''))" class="answer answer4"></div>
                  </div>
                
                </div>
                <div @click="$refs.fullpage.api.moveSectionDown()" class="bottom-actions primary-btn" :class="(sheet[index].continuable ? '' : 'non-clickable')">Continue</div>
            </div>
          </div>

          <div class="section score-section">
            <div class="score-section-inner">
              <h1>Thanks for getting to know us!</h1>
              <a href="https://home.hbrconsulting.com/SitePages/TalentSite.aspx"><div class="score-button view-score primary-btn"><b style="transition: 0ms">Return to Talent Site</b></div></a>
            </div>
          </div>

        </full-page>
      </div>
    </div>
  </transition>
</template>

<script>
import firebase from "firebase";
import store from '../store';

import CircleProgress from '../components/CircleProgress';

export default {
  name: 'Quiz',
  components: {
    CircleProgress
  },
  data() {
      return {
          remove: [],
          messages: [
              {
                  q: 'Who enjoys watching reality TV shows based in Alaska?',
                  status: 0
              },
              {
                  q: 'Who plays the guitar and banjo?',
                  status: 0
              },
              {
                  q: 'Who can move their ears?',
                  status: 0
              },
              {
                  q: 'Who was an avid surfer?',
                  status: 0
              },
              {
                  q: 'Who was nominated for an Emmy Award for their role as supporting actress in a Christian TV Show?',
                  status: 0
              },
              {
                  q: 'Who is considered a mutant, twice? They have syndactyly, which means they have twin toes and secondly their MC1R gene mutated a number of times, which caused them to have their certain hair color?',
                  status: 0
              },
              {
                  q: 'Who is originally from Michigan?',
                  status: 0
              },
              {
                  q: 'Who plays Super Smash Bros competitively, and regularly attends tournaments?',
                  status: 0
              },
              {
                  q: 'Who enjoys watching Disney movies and eating spicy food?',
                  status: 0
              },
              {
                  q: 'Who is trainined in Krav Maga?',
                  status: 0
              },
          ],
          stale: false,
          ani: 1,
          ans: null,
          continue: false,
          options: {
              scrollingSpeed: 1000,
              fadingEffect: true,
              setAutoscrolling: false,
              setWheelScrolling: false,
              setAllowScrolling: false,
              onLeave: (origin, destination, direction) => {
                console.log(this);
                this.handleLeave(origin, destination, direction);
              }
          },
          failedAttempts: [],
          questions: [],
          answerSheet: [],
          answerInputs: [],
          sheet: [],
          showScore: false,
          finalPercent: 0,
          animatedProgress: 0,
          pass: false,
          fail: false,
          activeSlide: 0,
          module: null,
          claims: {},
          userRef: {
            progress: {
              advisory: null,
              managed_services: null,
              operations: null
            },
            completed: []
          },
          quizzes: {
            advisory: [],
            managed_services: [],
            operations: [],
            talent: [
                {
                    answer1: 'Reshma',
                    answer2: 'Axelle',
                    answer3: 'April',
                    answer4: 'Dimple',
                    correct: 'April',
                    lessonID: '000',
                    questionNumber: '1',
                },
                {
                    answer1: 'Tenia',
                    answer2: 'Dimple',
                    answer3: 'Trent',
                    answer4: 'Mike',
                    correct: 'Mike',
                    lessonID: '000',
                    questionNumber: '2',
                },
                {
                    answer1: 'Dimple',
                    answer2: 'Lori',
                    answer3: 'Reshma',
                    answer4: 'Tajai',
                    correct: 'Dimple',
                    lessonID: '000',
                    questionNumber: '3',
                },
                {
                    answer1: 'Tajai',
                    answer2: 'Mike',
                    answer3: 'Tenia',
                    answer4: 'Trent',
                    correct: 'Tenia',
                    lessonID: '000',
                    questionNumber: '4',
                },
                {
                    answer1: 'Tiffany',
                    answer2: 'Axelle',
                    answer3: 'Tajai',
                    answer4: 'Reshma',
                    correct: 'Tiffany',
                    lessonID: '000',
                    questionNumber: '5',
                },
                {
                    answer1: 'Mike',
                    answer2: 'Reshma',
                    answer3: 'Lori',
                    answer4: 'Tajai',
                    correct: 'Lori',
                    questionNumber: '6',
                },
                {
                    answer1: 'April',
                    answer2: 'Reshma',
                    answer3: 'Tenia',
                    answer4: 'Mike',
                    correct: 'Reshma',
                    lessonID: '000',
                    questionNumber: '7',
                },
                {
                    answer1: 'Axelle',
                    answer2: 'Mike',
                    answer3: 'Trent',
                    answer4: 'Tajai',
                    correct: 'Trent',
                    lessonID: '000',
                    questionNumber: '8',
                },
                {
                    answer1: 'Tajai',
                    answer2: 'Tenia',
                    answer3: 'Dimple',
                    answer4: 'Tiffany',
                    correct: 'Tajai',
                    lessonID: '000',
                    questionNumber: '9',
                },
                {
                    answer1: 'Axelle',
                    answer2: 'Tiffany',
                    answer3: 'Reshma',
                    answer4: 'Mike',
                    correct: 'Axelle',
                    lessonID: '000',
                    questionNumber: '10',
                },
            ]
          }
      }
  },
  created() {
    this.fetchQuestions();
    this.fetchQuizzes();
    //this.setup();
    this.fetchUser();
    this.bindData();
    //console.clear();
    console.log('BEGIN CLOCK FOR QUIZ');
    console.log('BEGIN CLOCK FOR QUIZ CONTEXT');

    console.log(this.questions);
  },
  mounted() {
    console.clear();
    console.log('TRIVIA LENGTH');
    console.log(document.getElementById('p1').getTotalLength());
  },
  computed: {
    dark() {
      return store.state.dark;
    },
    context() {
      return this.$route.params.current;
    },
    isCorrect() {
      if(this.continue) {
        if(this.ans == this.questions[0].correct) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    nextRoute() {
      var str = "" + parseInt(parseInt(this.context) + 1);
      var pad = "000";
      var ans = pad.substring(0, pad.length - str.length) + str;

      console.log(ans);

      return '/lesson/' + ans;
    },
    formatContext() {
      var str = "" + parseInt(parseInt(this.context));
      var pad = "000";
      var ans = pad.substring(0, pad.length - str.length) + str;

      console.log(ans);

      return ans;
    },
  },
  methods: {
    getNewTotal(numCompleted) {
      //get total number of modules

      var self = this;
      var fireRef = firebase.firestore().collection("quizzes");
      var currentHighest = 0;
      var numLessons;

      //console.clear();
      console.log(numCompleted);

      fireRef.get().then((docs) => {
        docs.forEach((doc) => {
          //console.log(parseInt(doc.data().lessonID));
          if(parseInt(doc.data().lessonID) > currentHighest) {
            currentHighest = parseInt(doc.data().lessonID)
            console.log(currentHighest);
          }
        });
        console.log(numLessons);
        
        numLessons = currentHighest;

        console.log( (numCompleted / numLessons) * 100 );
        self.newTotal = ( (numCompleted / numLessons) * 100 );
      });

      /*fireRef.where('module','==','Advisory').get().then((docs) => {
        docs.forEach((doc) => {
          //console.log(parseInt(doc.data().lessonID));
          if(parseInt(doc.data().lessonID) > currentHighest) {
            currentHighest = parseInt(doc.data().lessonID)
            console.log(currentHighest);
          }
        });
        console.log(numLessons);
        
        numLessons = currentHighest;

        console.log( (numCompleted / numLessons) * 100 );
        self.newTotal = ( (numCompleted / numLessons) * 100 );
      });*/
    },
    /*async setup() {
        console.log('setup jazz');
        this.claims = await this.$auth.getUser(),
        console.log(this.claims);
        this.bindData();
    },
    async isAuthenticated() {
        this.authenticated = await this.$auth.isAuthenticated();
    },*/
    fetchUser() {
      var self = this;

      self.claims = firebase.auth().currentUser;
      //console.clear();
      console.log(self.claims);
    },
    fetchQuizzes() {
        var self = this;
        console.log('fetching lessons');

        firebase.firestore().collection('quizzes').get().then((docs) => {
            docs.forEach((doc) => {
                console.log();
                console.log(doc.data());
                console.log();
                if(doc.data().module == 'Advisory') {
                    self.quizzes.advisory.push(doc.data());
                }
                else if(doc.data().module == 'Managed Services') {
                    self.quizzes.managed_services.push(doc.data());
                }
                else if(doc.data().module == 'Operations') {
                    self.quizzes.operations.push(doc.data());
                }
                else {
                    console.error('Unkown module');
                }
            });
            //console.clear();
            console.log();
            console.log('quizzes fetched: ');
            console.log(self.quizzes.advisory);
            console.log(self.quizzes.managed_services);
            console.log(self.quizzes.operations);
            console.log(self.quizzes.talent);

            // ---------- filter quizzes ----------
            
            //self.filterQuizzes(self.quizzes.advisory);
            //self.filterQuizzes(self.quizzes.managed_services);
            //self.filterQuizzes(self.quizzes.operations);

            //console.clear();
            //console.log();
            //console.log(self.answerSheet);
            //console.log();
            //console.log('looks like we had what we needed all along: ');
            //console.log();
            //console.log('advisory length', self.quizzes.advisory.length);
            //console.log('managed services length', self.quizzes.managed_services.length);
            //console.log('operations length', self.quizzes.operations.length);
        });
    },
    filterQuizzes(context) {
        const na = [...new Set(context)]; // set

        var sorted = [];
        var trash = [];
    
        na.forEach((item) => {
            if(!trash.includes(item.serviceLine)) {
                sorted.push({practiceGroup: item.practiceGroup, serviceLine: item.serviceLine, lessonID: item.lessonID});
                trash.push(item.serviceLine);
                console.log(item.serviceLine);
            }
        });
        
        if(context == this.quizzes.advisory) { //advisory
            this.quizzes.advisory = sorted;
        }
        else if(context == this.quizzes.managed_services) { //managed_services
            this.quizzes.managed_services = sorted;
        }
        else { //operations
            this.quizzes.operations = sorted;
        }
    },
    fetchQuestions() {
      var self = this;
      var isTalent = true;

      if(isTalent) {
          this.quizzes.talent.forEach((doc) => {
              this.questions.push(doc);
              this.answerSheet.push(doc);
              this.sheet.push(doc);
              this.remove.push(false);
          });
          /*for(let i = 0; i < this.questions.length; i++) {
            this.messages.push(this.questions[i].question);
          }*/
      } else {
        firebase.firestore().collection('quizzes').where('lessonID', '==', this.formatContext).get().then((docs) => {
            docs.forEach((doc) => {
                self.questions.push(doc.data()); //fetching questions
                self.answerSheet.push(doc.data().correct); //fetching correct answers
                self.sheet.push(doc.data()); //fetching all quiz objects
                self.module = doc.data().module;
            });
        });
      }
    },
    getContextRow(choice) {
        if(choice % 4 == 0) {
            return [choice - 1, choice - 2, choice - 3];
        } else if(choice % 4 == 3) {
            return [choice - 1, choice - 2, choice + 1];
        } else if(choice % 4 == 2) {
            return [choice - 1, choice + 1, choice + 2];
        } else {
            return [choice + 1, choice + 2, choice + 3];
        }
    },
    handleAns(a, choice, index) {
      console.log(a);

      this.ans = choice;
      this.answerInputs[index] = choice; //record ansewr for current question
      this.sheet[index].continuable = true; //only allow continue if question answered
      this.sheet[index].answered = choice;

      var correctIndex;
      var contextRow;

      console.log('choice:', choice);
      console.log('question index:', index);
      console.log('context row:', contextRow);

      if(a == this.questions[index].correct) {
          this.messages[index].status = 1;
          this.messages[index].q = 'You got it!';
          contextRow = this.getContextRow(choice);
      } else {
          //grab index of correct answer
          this.getContextRow(choice).forEach((a) => {
              if(document.getElementById('a' + a).classList.contains(this.questions[index].correct)) {
                  console.clear();
                  console.log('correct index', a);
                  correctIndex = a;
              }
          });
          this.messages[index].status = 2;
          this.messages[index].q = 'The correct answer was ' + this.questions[index].correct + '!';
          contextRow = this.getContextRow(correctIndex);
      }

      contextRow.forEach((a) => {
          this.remove[a] = true;
      });

      this.$forceUpdate(); //thank god for this magic spell
    },
    getScore() {
      var numCorrect = 0;
      var total = this.answerSheet.length;
      var score;

      for(let i = 0; i < total; i++) {
        if(this.answerInputs[i] == this.answerSheet[i]) {
          numCorrect++;
        }
      }

      score = numCorrect / total;

      var finalPercent = (score * 100);

      this.finalPercent = parseInt(finalPercent);

      console.log('Final score: ', finalPercent);

      this.showScore = true;

      console.log('show score?: ', this.showScore);
      
      setTimeout(() => {
        this.animatePercent();
      }, 1000);
    },
    animatePercent() {
      var self = this;
      var count = 0;
      var up = setInterval(() => {
        this.animatedProgress = count;
        count++;
      }, 2000 / this.finalPercent);

      setTimeout(() => {
        clearInterval(up);
        self.animatedProgress = this.finalPercent;
        self.passFail();
      }, 2000);
      
    },
    passFail() {
      if(!this.stale) {
        if(this.finalPercent >= 90) {

          var self = this;

          this.pass = true;
          this.fail = false;

          //update remote score
          //console.clear();

          console.log('claims: ', this.claims);
          console.log("UPDATING SCORE FOR ", this.claims.uid, "..........");
          console.log('PUSHING ' + this.context + " TO COMPLETED ARRAY..........");

          var fireRef = firebase.firestore().collection("users").doc(this.claims.uid);
          
          if(self.userRef.completed.includes(this.context)) {
            console.log('lesson already completed!');
            this.stale = true;
          }
          else { //calculate new total, aggregate progress, and update completed[]

            var a_length = this.quizzes.advisory.length;
            var ms_length = this.quizzes.managed_services.length;
            var o_length = this.quizzes.operations.length;
            var total_lessons = a_length + ms_length + o_length;

            console.log('a_length: ', a_length);
            console.log('ms_length: ', ms_length);
            console.log('o_length: ', o_length);
            console.log('total_lessons: ', total_lessons);

            // ----- calculations -----

            var a_completed = 0;
            var ms_completed = 0;
            var o_completed = 0;

            var currentCompleted = [];

            self.userRef.completed.forEach((lesson) => {
              currentCompleted.push(lesson.lessonID);
            });

            //self.userRef.completed.push(self.context);
            self.userRef.completed.push({ module: self.module, lessonID: parseInt(self.context), score: self.finalPercent, timestamp: Date.now() });

            self.userRef.completed.forEach((lesson) => {
              if(lesson.module == 'Advisory') {
                a_completed++;
              }
              else if(lesson.module == 'Managed Services') {
                ms_completed++;
              }
              else {
                o_completed++;
              }
            });

            var new_a_progress = parseInt((a_completed == 0 ? 0 : ( a_completed / a_length )) * 100);
            var new_ms_progress = parseInt((ms_completed == 0 ? 0 : ( ms_completed / ms_length  )) * 100);
            var new_o_progress = parseInt((o_completed == 0 ? 0 : ( o_completed / o_length )) * 100);
            var new_total = parseInt((self.userRef.completed.length / total_lessons) * 100);

            //console.clear();
            console.log('DATA PRE-POST');
            console.log('completed', self.userRef.completed);
            console.log('new_a_progress', new_a_progress);
            console.log('new_ms_progress', new_ms_progress);
            console.log('new_o_progress', new_o_progress);
            console.log('new_total', new_total);

            fireRef.update({
              completed: self.userRef.completed,
              progress: {
                advisory: new_a_progress,
                managed_services: new_ms_progress,
                operations: new_o_progress,
                total: new_total
              }
            });
          }
        }
        else {
          this.pass = false;
          this.fail = true;

          self.userRef.failedAttempts.push({ score: self.score, lessonID: parseInt(self.context) });

          firebase.firestore().collection('users').doc(this.claims.uid).update({
            failedAttempts: self.userRef.failedAttempts
          });
        }

        console.log('pass?: ', this.pass);
      } else {
        console.log('quiz already completed');
      }
    },

    handleLeave(origin, destination, direction) {
      console.log('origin', origin);
      console.log('destination', destination);
      console.log('direction', direction);
      //console.clear();
      this.activeSlide = destination.index;
    },
    bindData() { //grabbing current progress data
        console.log('binding data..........');
        var self = this;
        var fireRef = firebase.firestore().collection('users');
        fireRef.doc(self.claims.uid).get().then((doc) => {
            console.log('exists?: ', doc.exists);

            console.log('doc exists');
            console.log(doc.data());
            self.userRef.progress.advisory = doc.data().progress.advisory;
            self.userRef.progress.managed_services = doc.data().progress.managed_services;
            self.userRef.progress.operations = doc.data().progress.operations;
            self.userRef.completed = doc.data().completed;
            self.userRef.failedAttempts = doc.data().failedAttempts;
            
        });

        //console.log('data successfully binded.');
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/global-styles/variables.scss';

.a-disappear {
    width: 0px !important;
    margin: 0px !important;
    opacity: 0;
    transition: 1s;
}

.a-appear {
    width: 220px !important;
    margin: 0px 12px 0px 12px !important;
    opacity: 1;
    transition: 1s;
}

.April {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/april.png?raw=true') !important;
}

.Dimple {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/dimple.png?raw=true') !important;
}

.Tenia {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/tenia.png?raw=true') !important;
}

.Reshma {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/reshma.png?raw=true') !important;
}

.Mike {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/mike.png?raw=true') !important;
}

.Tiffany {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/tiffany.png?raw=true') !important;
}

.Lori {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/lori.png?raw=true') !important;
}

.Tajai {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/banner-chop/tajai.png?raw=true') !important;
}

.Axelle {
  background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/chop2/axelle.png?raw=true');
}

.Trent {
  background-image: url('https://github.com/tbrew1023/icommon/blob/master/images/HBR/sharepoint-banners/chop2/trent.png?raw=true');
}

.answer1 {
    
}

.answer2 {

}

.answer3 {

}

.answer4 {

}

.question-container {
    //border: red solid 3px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-inactive {
  //background: red !important;
  transform: scale(0.9);
  opacity: 0;
}

.score-options-container {
  display: flex;
  //opacity: 0;
  //animation: flyin 1s ease forwards 2s;
  margin-top: 64px;

  .btn, .primary-btn {
    width: 220px;
    height: 60px;
    color: white;
    background: black;
    margin-left: 3px;
    margin-right: 3px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0;

    &:hover {
      //box-shadow: $softShadow;
      transform: scale(1.1);
      filter: brightness(0.86);
    }
  }

  .btn1 {
    animation: flyin 600ms ease forwards 2s;
    background: $colorGreen;
    color: white;
    border-radius: 90px 4px 4px 90px;
    //font-weight: bold;
    //border: 2px solid black;

    a {
      color: white;
    }
  }

  .btn2 {
    animation: flyin 600ms ease forwards 5s;
    background: $colorGray1;
    color: black;
    border-radius: 4px 4px 4px 4px;
    //border: 2px solid black;
    //font-weight: bold;
  }

  .btn3 {
    animation: flyin 600ms ease forwards 5s;
    background: $colorGray1;
    color: black;
    border-radius: 4px 90px 90px 4px;
    //border: 2px solid black;
    //font-weight: bold;
  }
}

.score-message {
  opacity: 0;
  font-weight: normal;
  animation: flyup 1s ease forwards 4.5s;
}

.pass-message {
  color: $colorGreen;
  //font-weight: normal;
  //color: black;
}

.fail-message {
  color: $colorRed;
  //font-weight: normal;
  //color: black;
}

.quiz-card {
  background: white;
  padding: $gap;
  position: absolute;
  margin: auto;
  left: 0px;
  right: 0px;
  top: 60px;
  bottom: 0px;
  height: max-content;
  max-height: 62%;
  box-shadow: $softerShadow;
  width: 70%;
  border-radius: $rad;
  transition: 1s;

  h3 {
      padding-bottom: $gap;
  }
}

.circle-boi {
  margin-top: 220px;
  animation: flyin 1s ease forwards, circle-shift 1s ease forwards 3.5s;
  transition: 2s;
}

.pass {
  color: $colorGreen;
  font-weight: bold;
}

.fail {
  color: $colorRed;
  font-weight: bold;
}

.final-percent {
  opacity: 0;
  animation: flyin 1s ease forwards 0.5s;
  font-size: 64px;
  font-weight: normal;
  margin-bottom: $gap;
  margin-top: 0px;
  transition: 300ms;
}

.juice-progress {
  height: 12px;
  width: 0%;
  background: white;
  border-radius: $rad;
  animation: progress 2s ease forwards 1s;
}

.juice {
  position: absolute;
  //background: rgba(0,0,0,0.15);
  height: 12px;
  width: 285px;
  margin-left: auto;
  margin-right: auto;
  border-radius: $rad;
  left: 0;
  right: 0;
  margin-top: 6px;
  //z-index: 9999;3
}

.juice-backdrop-container {
  //background: red;
  width: 100%;
  height: 24px;
  border-radius: $rad;
  display: flex;

  .juice-empty {
    background: $colorGray2;
    width: 85%;
    border-radius: $rad 0px 0px $rad;
  }

  .pass-marker {
    background: $colorGreen;
    width: 15%;
    border-radius: 0px $rad $rad 0px;
  }
}

.score-bar {
  //background: gray;
  width: 300px;
  height: 24px;
  border-radius: $rad;
  opacity: 0;
  animation: flyin 0.6s ease forwards 1s;
}

.modal-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: $colorBackdrop;
  z-index: 999;
  animation: flyin 600ms ease forwards;
}

.modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  width: 60%;
  height: 80%;
  border-radius: $rad;
  box-shadow: $softerShadow;
  z-index: 999;
}

.score-circle {
  opacity: 0;
  animation: flyin 1s forwards ease 1s;
}

.quiz-light {
  .quiz-container {
    background: $colorBackdrop !important;
  }
}

.quiz-dark {
  .btn1 {
    background: $colorGreen;
  }

  .btn2, .btn3 {
    background: $colorDarkMid;
  }

  .modal-container {
    background: $colorDarkMid;
  }

  .modal {
    background: $colorDarkLight;
  }

  .arrows, .primary-btn, .bottom-actions {
    filter: invert(1);
  }

  #logo {
    filter: invert(1);
  }

  .quiz-container {
    background: $colorDarkMid !important;
  }
  
  .quiz-card {
    background: $colorDarkLight;
  }

  .answer {
    //background: $colorDarkMid !important;
  }

  .letter-container {
    background: black !important;
    //opacity: 0.6 !important;
  }

  .clickable {
    border: 2px solid white !important;
    color: white !important;
    pointer-events: all;
    opacity: 1;

    &:hover {
      background: white !important;
      color: black !important;
    }
  }
}

.non-clickable {
  pointer-events: none;
  opacity: 0.2;
}

.begin-button {
  margin-top: 48px;
  width: 100px !important;
  animation: flyup 1s ease forwards 2.5s;
  opacity: 0;
}

.score-button {
  background: black;
  color: white;
  border: solid 2px black;
  cursor: pointer;
  transition: 300ms;
  width: 180px;
  padding: 12px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 90px;

  &:hover {
    background: transparent;
    color: black;
  }
}

.section {
  height: 100vh;
}

.correct {
  background-color: green !important;
  color: white !important;

  .letter-container {
    background: darkgreen !important;
  }
}

.bottom-actions {
  margin-top: 60px;
  margin-bottom: 24px;
  background: transparent;
  border: 2px black solid;
  border-radius: $rad;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
  color: black;
  font-weight: bold;
  padding: 6px 3px;
  cursor: pointer;
  transition: 300ms;

  &:hover {
    background: black;
    color: white;
  }
}

.answer-selected {

  span {
    font-weight: bold;
  }

  .letter-container {
    width: 110px !important;
    background: $colorLightBlue !important;
  }
}

$answerHeight: 60px;
$answerRad: 200px;

.answer {
  //background: $colorBackdrop;
  //margin-bottom: $gap;
  height: 220px;
  width: 220px;
  margin-left: 12px;
  margin-right: 12px;
  border-radius: 12px;
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  transition: 600ms;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  span {
    font-size: 18px !important;
    font-weight: bold;
    color: white;
    background: linear-gradient(0deg, black, transparent);
    width: 100%;
    border-radius: 0px 0px 12px 12px;
    margin: 0px !important;
    text-align: left;
    padding-left: 24px;
  }

  &:hover {
    transform: scale(0.9);
  }

.answer-dark {
    background: $colorDarkMid;
    margin-bottom: $gap;
    height: $answerHeight;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    border-radius: $answerRad;
    display: flex;
    cursor: pointer;
    transition: 300ms;

    .letter-container {
      background: green;
    }

    &:hover {
      //background:rgba(0, 0, 0, 0.04);
      .letter-container {
        width: $answerHeight * 1.4;
      }
    }
  }

  span {
    line-height: $answerHeight;
    font-size: 14px;
    margin-left: $gap / 1.5;
  }

  .letter-container {
    width: $answerHeight;
    color: white;
    border-radius: $answerRad;
    line-height: $answerHeight;
    font-weight: bold;
    font-size: 18px;
    transition: 300ms;
  }
}

.letter-container {
    background: $colorGray3;
}

.answer3 .letter-container {
  //background: $colorBlue;
  //background: $colorGray3;
}

.answer2 .letter-container {
  //background: $colorLightBlue;
  //background: $colorGray3;
}

.answer1 .letter-container {
  //background: $colorGreen;
  //background:$colorGray3;
}

.answer4 .letter-container {
  //background: $colorDarkBlue;
  //background: $colorGray3;
}

.question-title {
  margin-top: $gap;
  margin-bottom: $gap;
  max-width: 1200px;
  justify-self: center;
  margin-left: auto;
  margin-right: auto;
}

#fullpage {
    //background: $colorGreen;
}

.quiz-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: $colorBackdrop;
}

.draw-intro {
  cursor: pointer;
}

// ---------- intro animation stuff ----------

#logo {
  animation: fill 1s ease forwards 1.8s;
  transition: 300ms;
  margin-left: 0px !important;
  //animation: shiftLogo 1s ease forwards 4s; 
}

#logo path:nth-child(1) {
  stroke-dasharray: 1096;
  stroke-dashoffset: 1096;
  animation: line-animate 8s ease-in forwards;
}
/*#logo path:nth-child(2) {
  stroke-dasharray: 194;
  stroke-dashoffset: 194;
  animation: line-animate 2s ease-in forwards 0.3s;
}
#logo path:nth-child(3) {
  stroke-dasharray: 127;
  stroke-dashoffset: 127;
  animation: line-animate 2s ease-in forwards 0.6s;
}
#logo path:nth-child(4) {
  stroke-dasharray: 178;
  stroke-dashoffset: 178;
  animation: line-animate 2s ease-in forwards 0.9s;
}
#logo path:nth-child(5) {
  stroke-dasharray: 188;
  stroke-dashoffset: 188;
  animation: line-animate 2s ease-in forwards 1.2s;
}*/

// ---------- intro 2 ----------

#logo2 {
  height: 400px;
  transition: 300ms;
  //margin-left: 72px;
  //transform: translateY(-400px);
  margin-left: 52px !important;
}

#logo2 path:nth-child(1) {
  animation: rise 1s ease-in forwards;
  opacity: 0;
}
#logo2 path:nth-child(2) {
  animation: rise 1s ease-in forwards 0.3s;
  opacity: 0;
}
#logo2 path:nth-child(3) {
  animation: rise 1s ease-in forwards 0.6s;
  opacity: 0;
}
#logo2 path:nth-child(4) {
  animation: rise 1s ease-in forwards 0.9s;
  opacity: 0;
}
#logo2 path:nth-child(5) {
  animation: rise 1s ease-in forwards 1.2s;
  opacity: 0;
}

// ---------- intro 3 ----------

#logo3 {
  transition: 300ms;
  margin-left: 52px !important;
  //margin-left: 72px;
}

#logo3 path:nth-child(1) {
  animation: grow 1s ease-in forwards;
  opacity: 0;
}
#logo3 path:nth-child(2) {
  animation: grow 1s ease-in forwards 0.3s;
  opacity: 0;
}
#logo3 path:nth-child(3) {
  animation: grow 1s ease-in forwards 0.6s;
  opacity: 0;
}
#logo3 path:nth-child(4) {
  animation: grow 1s ease-in forwards 0.9s;
  opacity: 0;
}
#logo3 path:nth-child(5) {
  animation: grow 1s ease-in forwards 1.2s;
  opacity: 0;
}

// --------- arrow things ----------

  .arrows {
    position: absolute;
    width: 30px;
    height: 30px;
    transform: translate(50%, 50%) scale(0.6);
    left: -30px;
    right: 0px;
    margin: auto;
    bottom: 112px;
    opacity: 0;
    animation: appear 2s ease forwards 3s;
  }
  
  .arrows:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-left: 26.66667px solid rgba(0, 0, 0, 0.7);
    border-bottom: 26.66667px solid rgba(0, 0, 0, 0.7);
    transform: translate(26.66667px, 106.66667px) rotate(-45deg);
    animation: arrows 3s linear infinite;
  }
  
  .arrows:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-left: 26.66667px solid rgba(0, 0, 0, 0.7);
    border-bottom: 26.66667px solid rgba(0, 0, 0, 0.7);
    transform: translate(53.33333px, 0px) rotate(-45deg);
    animation: arrows 3s linear infinite -1.5s;
  }
  
  @keyframes arrows {
    0% {
      border-left: 10px solid transparent;
      border-bottom: 10px solid transparent;
      transform: translate(-13.33333px, -53.33333px) rotate(-45deg);
    }
    10%, 90% {
      border-left: 10px solid transparent;
      border-bottom: 10px solid transparent;
    }
    50% {
      border-left: 10px solid black;
      border-bottom: 10px solid black;
      transform: translate(-13.33333px, 0px) rotate(-45deg);
    }
    100% {
      border-left: 26.66667px solid transparent;
      border-bottom: 26.66667px solid transparent;
      transform: translate(-13.33333px, 53.33333px) rotate(-45deg);
    }
  }

  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes progress {
    0% {
      width: 0%;
    }
  }

  @keyframes circle-shift {
    to {
      transform: scale(0.75);
      margin-top: -60px;
    }
  }

</style>